'use strict';
const base_url = window.location.href;
const base_url_come = base_url.indexOf('.com');
const base_url_protocol = location.protocol;
const base_url_domain = base_url.substr(0, base_url_come + 4);
const base_url_cookie_arr = base_url_domain.split('.');
const base_url_cookie = base_url_cookie_arr[base_url_cookie_arr.length - 2];
const Cookie = {
  // 取cookie
  getCookie: function (name, domain, callback, encode) {
    const arg = name + '=';
    const alen = arg.length;
    const clen = document.cookie.length;
    let i = 0;
    let j = 0;
    while (i < clen) {
      j = i + alen;
      if (document.cookie.substring(i, j) == arg) {
        const CookieVal = this.getCookieVal(j, encode);
        callback && callback(CookieVal);
        return CookieVal;
      }
      i = document.cookie.indexOf(' ', i) + 1;
      if (i == 0) {
        callback && callback(null);
        return null;
      }
    }
  },
  setCookie: function (name, value, domain, sessionExpires = false) {
    const argv = arguments;
    const argc = arguments.length;
    const now = new Date();
    let expires = new Date(now.getFullYear(), now.getMonth() + 1, now.getUTCDate());
    if (sessionExpires) {
      expires = null;
    }
    const path = '/';
    // TODO
    var domain = argc > 2 ? argv[2] : '.' + base_url_cookie + '.com';
    const secure = false;
    try {
      document.cookie =
        name +
        '=' +
        escape(value) +
        (expires == null ? '' : '; expires=' + expires.toGMTString()) +
        (path == null ? '' : '; path=' + path) +
        (domain == null ? '' : '; domain=' + domain) +
        (secure == true ? '; secure' : '');
    } catch (error) {
      console.log('setCookie error:', error);
    }
  },
  clearCookie: function () {
    const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (let i = keys.length; i--;) {
        document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
      }
    }
  },
  getAllCookie: function (domain, cb) {
    const cookies = document.cookie;
    cb && cb(cookies);
  },
  getCookieVal: function (offset, encode) {
    let endstr = document.cookie.indexOf(';', offset);
    if (endstr == -1) {
      endstr = document.cookie.length;
    }
    if (encode == false) {
      return document.cookie.substring(offset, endstr);
    } else {
      return unescape(document.cookie.substring(offset, endstr));
    }
  },

  /**
   * 获cookie中的罗盘数据值
   * 这里加async是为了兼容RN的该方法
   */
  async getCompassData() {
    const cookies = document.cookie;
    const compass = {};
    if (cookies) {
      // 获取cookie中渠道
      compass.source_id = this.getCookie('mijiasn') || '';

      // 获取cookie中的反馈字段
      // compass.feedback = this.getCookie('feedback') || '';

      // 获取cookie中的mijiasn
      compass.mijiasn = this.getCookie('mijiasn') || '';
    }
    return compass;
  },
};
module.exports = Cookie;
